import { get, put, post, remove, patch } from "./http.service";
import { delay } from "../utils/utils";

const AnnouncementService = {
  getAnnouncement: id => get(`announcement/${id}`),
  updateAnnouncement: (id, body) => put(`announcement/${id}`, body),
};
export default AnnouncementService;
